import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/config/mensajes';
import ListarMensajes from './ListarMensajes';


const ms2p = (state) => {
  return {
    ...state.mensajes,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(ListarMensajes);
